export const EmailOtpTemplate = ( otp, title, description ) => `<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
<html>
<head>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8" >
<link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700" rel="stylesheet">
<style type="text/css">
html { -webkit-text-size-adjust: none; -ms-text-size-adjust: none;}
​
	@media only screen and (min-device-width: 750px) {
		.table750 {width: 750px !important;}
	}
	@media only screen and (max-device-width: 750px), only screen and (max-width: 750px){
      table[class="table750"] {width: 100% !important;}
      .mob_b {width: 93% !important; max-width: 93% !important; min-width: 93% !important;}
      .mob_b1 {width: 100% !important; max-width: 100% !important; min-width: 100% !important;}
      .mob_left {text-align: left !important;}
      .mob_center {text-align: center !important;}
      .mob_soc {width: 50% !important; max-width: 50% !important; min-width: 50% !important;}
      .mob_menu {width: 50% !important; max-width: 50% !important; min-width: 50% !important; box-shadow: inset -1px -1px 0 0 rgba(255, 255, 255, 0.2); }
      .mob_btn {width: 100% !important; max-width: 100% !important; min-width: 100% !important;}
      .mob_pad {width: 15px !important; max-width: 15px !important; min-width: 15px !important;}
      .min_pad2 {height: 30px !important; max-height: 30px !important; min-height: 15px !important;}
      .top_pad {height: 15px !important; max-height: 15px !important; min-height: 15px !important;}
      .top_pad2 {height: 50px !important; max-height: 50px !important; min-height: 50px !important;}
      .mob_title1 {font-size: 36px !important; line-height: 40px !important;}
      .mob_title2 {font-size: 26px !important; line-height: 33px !important;}
      .mob_txt {font-size: 20px !important; line-height: 25px !important;}
 	}
   @media only screen and (max-device-width: 550px), only screen and (max-width: 550px){
      .mod_div {display: block !important;}
   }
	.table750 {width: 750px;}
</style>
</head>
<body style="margin: 0; padding: 0;">
​
<table cellpadding="0" cellspacing="0" border="0" width="100%" style="background: #fff; min-width: 340px; font-size: 1px; line-height: normal;">
 	<tr>
   	<td align="center" valign="top">   			
   		<!--[if (gte mso 9)|(IE)]>
         <table border="0" cellspacing="0" cellpadding="0">
         <tr><td align="center" valign="top" width="750"><![endif]-->
   		<table cellpadding="0" cellspacing="0" border="0" width="750" class="table750" style="width: 100%; max-width: 750px; min-width: 340px; background: #fff;">
   			<tr>
               <td class="mob_pad" width="25" style="width: 25px; max-width: 25px; min-width: 25px;">&nbsp;</td>
   				<td align="center" valign="top" style="background: #FFF;">
​
                  <table cellpadding="0" cellspacing="0" border="0" width="100%" style="width: 100% !important; min-width: 100%; max-width: 100%; background: #FFF;">
                     <tr>
                        <td align="right" valign="top">
                           <div class="top_pad" style="height: 25px; line-height: 25px; font-size: 23px;">&nbsp;</div>
                        </td>
                     </tr>
                  </table>
​
                  <table cellpadding="0" cellspacing="0" border="0" width="88%" style="width: 88% !important; min-width: 88%; max-width: 88%; background: #FFF; border-top-left-radius: 40px; border-top-right-radius: 40px; ">
                     <tr>
                        <td align="center" valign="top">
                           <div style="height: 40px; line-height: 40px; font-size: 38px;">&nbsp;</div>
                           <a href="#" target="_blank" style="display: block; max-width: 128px;">
                              <img src="https://storage.googleapis.com/smsmemailassets/logo.png" alt="img" width="90" border="0" style="display: block; width: 90px;" />
                           </a>
                           <div class="top_pad2" style="height: 20px; line-height: 70px; font-size: 68px;">&nbsp;</div>
                        </td>
                     </tr>
                  </table>
​
                                    <div style="height: 35px; line-height: 8px; font-size: 6px;">&nbsp;</div>
​
​
                  <table cellpadding="0" cellspacing="0" border="0" width="88%" style="width: 88% !important; min-width: 88%; max-width: 88%; background: #FFF; border-bottom-left-radius: 40px; border-bottom-right-radius: 40px; ">
                     <tr>
                        <td align="center" valign="top">
						       <font face="'Source Sans Pro', sans-serif" color="#000000" style="font-size: 20px; line-height: 28px;">
                              <span class="mob_title1" style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #1a1a1a; font-size: 35px; line-height: 55px; font-weight: 300; letter-spacing: 0px;">OTP for Push Notification: ${otp}</span>
​
                              <div style="height: 25px; line-height: 8px; font-size: 6px;">&nbsp;</div>
                              <p>
                                 <span class="mob_title1" style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #1a1a1a; font-size: 25px; line-height: 55px; font-weight: 600; letter-spacing: 0px;">${title}</span>
                                       <p>
                                 <span class="mob_title1" style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #1a1a1a; font-size: 25px; line-height: 55px; font-weight: 600; letter-spacing: 0px;">${description}</span>
​
               
                           </font>
                        </td>
                     </tr>
                  </table>
​
                  <div style="height: 25px; line-height: 8px; font-size: 6px;">&nbsp;</div>
​
                  
                 
​
                <table cellpadding="0" cellspacing="0" border="0" width="100%" style="width: 100% !important; min-width: 100%; max-width: 100%; background: #FFF;">
                     <tr>
                        <td align="center" valign="top">
                           <div style="height: 34px; line-height: 34px; font-size: 32px;">&nbsp;</div>
                           
                                    <div style="height: 34px; line-height: 34px; font-size: 32px;">&nbsp;</div>
                                    <font face="'Source Sans Pro', sans-serif" color="#868686" style="font-size: 17px; line-height: 20px;">
                                       <span style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #868686; font-size: 17px; line-height: 20px;">Copyright &copy; White Sesame LLC.</span>
                                    </font>
                                    <div style="height: 3px; line-height: 3px; font-size: 1px;">&nbsp;</div>
                                    <font face="'Source Sans Pro', sans-serif" color="#1a1a1a" style="font-size: 17px; line-height: 20px;">
                                       <span style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #1a1a1a; font-size: 17px; line-height: 20px;"><a href="mailto:care@smsm.sa" target="_blank" style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #1a1a1a; font-size: 17px; line-height: 20px; text-decoration: none;">care@smsm.sa</a> &nbsp;&nbsp;|&nbsp;&nbsp; &nbsp; <a href="#" target="_blank" style="font-family: 'Source Sans Pro', Arial, Tahoma, Geneva, sans-serif; color: #1a1a1a; font-size: 17px; line-height: 20px; text-decoration: none;">T&C</a></span>
                                    </font>
                                    <div style="height: 35px; line-height: 35px; font-size: 33px;">&nbsp;</div>
                                    <table cellpadding="0" cellspacing="0" border="0">
                                       <tr>
                                          <td align="center" valign="top">
                                             <a href="https://www.instagram.com/smsm_company/" target="_blank" style="display: block; max-width: 19px;">
                                                <img src="https://storage.googleapis.com/smsmemailassets/soc_1.png" alt="img" width="19" border="0" style="display: block; width: 19px;" />
                                             </a>
                                          </td>
                                          <td width="45" style="width: 45px; max-width: 45px; min-width: 45px;">&nbsp;</td>
                                          <td align="center" valign="top">
                                             <a href="https://www.facebook.com/smsm.company" target="_blank" style="display: block; max-width: 18px;">
                                                <img src="https://storage.googleapis.com/smsmemailassets/soc_2.png" alt="img" width="18" border="0" style="display: block; width: 18px;" />
                                             </a>
                                          </td>
                                          <td width="45" style="width: 45px; max-width: 45px; min-width: 45px;">&nbsp;</td>
                                          <td align="center" valign="top">
                                             <a href="https://twitter.com/smsm_company" target="_blank" style="display: block; max-width: 21px;">
                                                <img src="https://storage.googleapis.com/smsmemailassets/soc_3.png" alt="img" width="21" border="0" style="display: block; width: 21px;" />
                                             </a>
                                          </td>
                                          <td width="45" style="width: 45px; max-width: 45px; min-width: 45px;">&nbsp;</td>
                                          <td align="center" valign="top">
                                             <a href="https://www.linkedin.com/company/sm-sm" target="_blank" style="display: block; max-width: 25px;">
                                                <img src="https://storage.googleapis.com/smsmemailassets/soc_4.png" alt="img" width="20" border="0" style="display: block; width: 20px;" />
                                             </a>
                                          </td>
                                       </tr>
                                    </table>
                                    <div style="height: 35px; line-height: 35px; font-size: 33px;">&nbsp;</div>
                                 </td>
                              </tr>
                           </table>
                        </td>
                     </tr>
                  </table>  
​
               </td>
               <td width="3%" style="width: 3%; max-width: 3%; min-width: 10px;">&nbsp;</td>
            </tr>
         </table>
         <!--[if (gte mso 9)|(IE)]>
         </td></tr>
         </table><![endif]-->
</body>
</html>`